export default "__VITE_ASSET__3I8ff6ZX__"